import React from "react";
import ReactDOM from "react-dom/client";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import englishTranslations from "./locales/en.json";
import spanishTranslations from "./locales/es.json";

// for rtl format comment out bootstrap.min.css and uncomment bootstrap.rtl.min.css
import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/css/bootstrap.rtl.min.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./sass/stylesheet.scss";

import "./index.scss";
import App from "./App";
import HermesPrivacy from "./components/HermesPrivacy";
import reportWebVitals from "./reportWebVitals";

i18n.use(initReactI18next).init({
	resources: {
		es: {
			translation: spanishTranslations,
		},
		en: {
			translation: englishTranslations,
		},
	},
	lng: "es",
	fallbackLng: "es",
	interpolation: {
		escapeValue: false,
	},
});

// Establecer meta title y description basados en el idioma actual
const updateMetaTags = () => {
	document.title = i18n.t("meta-title");
	document
		.querySelector('meta[name="description"]')
		.setAttribute("content", i18n.t("meta-description"));
};

// Actualizar metadatos al cargar la página
updateMetaTags();

// Actualizar metadatos cuando cambie el idioma
i18n.on("languageChanged", () => {
	updateMetaTags();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const RootComponent = window.location.pathname === "/privacidad-hermes" ? HermesPrivacy : App;
root.render(
	<React.StrictMode>
		<RootComponent />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
